import businessService from 'Services/BusinessService'
import businessAccountGroupService from 'Services/BusinessAccountGroupService'

// initial state
const state = {
  businesses: []
}

// getters
const getters = {
  business: state => businessId => state.businesses.find(business => business.businessId === businessId) || null,
  businessAccountGroups: (state, getters) => businessId => getters.business(businessId).accountGroups || []
}

const actions = {
  filterBusinesses: ({ commit }, { filterContext }) => {
    const { request, cancelToken } = businessService.getAll(filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setBusinesses', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getBusinesses: ({ dispatch }) => {
    return dispatch('filterBusinesses').then(({ promise }) => promise.then(result => result.data))
  },

  getBusiness: ({ commit }, { business }) => {
    return new Promise((resolve, reject) => {
      businessService.get(business.id).then(result => {
        commit(state.businesses.some(item => item.businessId === result.businessId) ? 'updateBusiness' : 'setBusiness', result)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getBusinessAccountGroups: ({ commit }, { businessId }) => {
    if (!businessId) {
        return Promise.reject(new Error('Business ID is required'))
    }

    return new Promise((resolve, reject) => {
        businessAccountGroupService.getAll({ business: { id: businessId } })
            .then(result => {
                commit('updateBusiness', { businessId, accountGroups: result.accountGroups })
                resolve(result.accountGroups)
            })
            .catch(error => {
                reject(error)
            })
    })
  },

  getBusinessAccount: ({ commit }, { businessId, accountNumber }) => {
    if (!businessId || !accountNumber) {
      return Promise.reject(new Error('Business ID and Account Number are required'))
    }

    return new Promise((resolve, reject) => {
      businessAccountGroupService.get({ businessId, accountNumber })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  setBusinesses (state, businesses) {
    state.businesses = businesses
  },

  setBusiness (state, business) {
    state.businesses.push(business)
  },

  updateBusiness (state, business) {
    state.businesses = state.businesses.map(item =>
      item.businessId === business.businessId ? Object.assign(item, business) : item
    )
  },

  deleteBusiness (state, businessId) {
    state.businesses = state.businesses.filter(business => business.businessId !== businessId)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
